var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.909 0C16.053 0 18.165 2.153 18.165 5.357V14.553C18.165 17.785 16.118 19.887 12.95 19.907L5.257 19.91C2.113 19.91 0 17.757 0 14.553V5.357C0 2.124 2.047 0.023 5.215 0.004L12.908 0H12.909ZM12.909 1.5L5.22 1.504C2.892 1.518 1.5 2.958 1.5 5.357V14.553C1.5 16.968 2.905 18.41 5.256 18.41L12.945 18.407C15.273 18.393 16.665 16.951 16.665 14.553V5.357C16.665 2.942 15.261 1.5 12.909 1.5ZM12.7161 13.4737C13.1301 13.4737 13.4661 13.8097 13.4661 14.2237C13.4661 14.6377 13.1301 14.9737 12.7161 14.9737H5.4961C5.0821 14.9737 4.7461 14.6377 4.7461 14.2237C4.7461 13.8097 5.0821 13.4737 5.4961 13.4737H12.7161ZM12.7161 9.2872C13.1301 9.2872 13.4661 9.6232 13.4661 10.0372C13.4661 10.4512 13.1301 10.7872 12.7161 10.7872H5.4961C5.0821 10.7872 4.7461 10.4512 4.7461 10.0372C4.7461 9.6232 5.0821 9.2872 5.4961 9.2872H12.7161ZM8.2508 5.1104C8.6648 5.1104 9.0008 5.4464 9.0008 5.8604C9.0008 6.2744 8.6648 6.6104 8.2508 6.6104H5.4958C5.0818 6.6104 4.7458 6.2744 4.7458 5.8604C4.7458 5.4464 5.0818 5.1104 5.4958 5.1104H8.2508Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.78f6a909f065c78c0dad3b293b3ca1a0.svg";
export { ForwardRef as ReactComponent };